import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Guid } from 'guid-typescript';
import lodash from 'lodash';

import ContainerScreen from '@/main/components/shared/containerScreen/containerLayout';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import Button from '@/main/components/shared/button/button';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';
import { InsurerSaveRequest } from '@/main/models/request/insurerRequest';
import { companyBusinessHourApi, insurerApi } from '@/main/api';
import {
  getTranslateByKey,
  removeEmptyValues,
  isShowControlByElementId,
  isNullUndefined
} from '@/main/services/utils';
import { ReasonTypeEnum } from '@/main/services/enum/ReasonEnum';
import {
  getSupplierType,
  useSupplierTypeReducer
} from '@/main/store/supplierType';
import {
  getManufacturers,
  useManufacturerReducer
} from '@/main/store/vehicle/manufacturer';
import { getReason, useReasonReducer } from '@/main/store/reason';
import {
  getDistributionRegion,
  useDistributionRegionReducer
} from '@/main/store/distributionRegion';
import { ReasonFilterRequest } from '@/main/models/request/reasonRequest';
import { DistributionRegionFilterRequest } from '@/main/models/request/distributionRegionRequest';
import { resetReducerPosition } from '@/main/store/position';
import { resetReducerCategory } from '@/main/store/category';
import { resetReducerSubcategory } from '@/main/store/subcategory';
import { resetReducerPartType } from '@/main/store/partType';
import ContactInfo, {
  formattedContactGet,
  formattedContactSave,
  IContactInfoState
} from '@/main/components/shared/contactInfo';
import AddressInfo, {
  IAddressInfoState
} from '@/main/components/shared/addressInfo';

import { KogTabsComponent } from '@/main/components/shared/tabs/tabs';
import { TabSettingRegister } from '@/main/components/shared/tabs/insurer/tabSettingRegister/tabSettingRegister';

import {
  ManufacturerRequest,
  SaveSupplierCompanyRelationRequest
} from '@/main/models/request';
import { ParameterTypesResponse } from '@/main/models/response/parameterTypesResponse';
import SectionInfo from './sectionInfo';
import BodyshopCompanyInfo, { IOptionBranch } from './bodyshopCompanyInfo';
import {
  InsurerRegisterProvider,
  IInsurerRegisterForm,
  useInsurerRegisterContext
} from './context';
import BusinessHoursModal, {
  IPeriodBusinessInfoState,
  defaultValuePeriodBusiness
} from '@/main/components/shared/businessHoursModal/businessHoursModal';
import * as S from './styles';
import { Controls } from '@/main/services/constants/constantsControl';
import { CustomError } from '@/main/services/class/customError';
import { PrioritySuppliersResponse } from '@/main/models/response/PrioritySuppliersResponse';
import { PartTypePerPartResponse } from '@/main/models/response/partTypePerPartResponse';
import { KOGAreaButtons } from '@/main/components/shared/styles';
import BusinessHoursGrid from '@/main/components/shared/businessHoursGrid/businessHoursGrid';
import { BusinessHourResponse } from '@/main/models/response';
import { parse } from 'date-fns';
import { formatDateToISOString } from '@/main/services/utilsDate';
import KogModalSideComponent from '@/main/components/modal/ModalSide';
import { TabHierarchyLevels } from './hierarchyLevels/tabHierarchyLevels';
import { TabInsurerClaimConfigurations } from './insurerClaimConfigurations/tabInsurerClaimConfigurations';
import VisualIdentity from './visualIdentity/visualIdentity';
import { convertImageToBase64, toBase64 } from '@/main/services/utilsFile';
import { CompanyTypeEnum } from '@/main/services/enum/CompanyTypeEnum';
import useAsyncModalConfirmReason from '@/main/components/shared/asyncModalConfirmReason/asyncModalConfirmReason';
import CompanyHistorical from '@/main/components/shared/companyHistorical/companyHistorical';
import TabHierarchy from '@/main/screens/registration/insurer/insurerRegisterScreen/hierarchyLevels/tabHierarchy';

interface ITabSettingRegister {
  guidInsurer: string | null;
  guidBodyshop: string | null;
  dataPeriodBusiness: BusinessHourResponse[];
}

function InsurerRegisterScreen() {
  const INTIAL_TAB_GENERAL_INFO: number = 0;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const methods = useFormContext<IInsurerRegisterForm>();
  const [searchParams, setSearchParams] = useSearchParams();
  const guidInsurerParams = searchParams.get('insurerGuid');
  const watcherCountry = methods.watch('country');
  const { isEdit, setIsEdit } = useInsurerRegisterContext();

  const [guidCompany, setGuidCompany] = useState<string | null>();
  const [getConfirmationReason, ModalConfirmationReason] = useAsyncModalConfirmReason();
  const [isLoadingInfo, setIsLoadingInfo] = useState<boolean>(false);
  const [dataContacts, setDataContacts] = useState<IContactInfoState[]>([]);
  const [initialDataContacts, setInitialDataContacts] = useState<IContactInfoState[]>([]);
  const [dataAddress, setDataAddress] = useState<IAddressInfoState[]>([]);
  const [initialDataAddress, setInitialDataAddress] = useState<IAddressInfoState[]>([]);
  const [dataBranchs, setDataBranchs] = useState<IOptionBranch[]>([]);
  const [initialDataBranchs, setInitialDataBranchs] = useState<IOptionBranch[]>([]);
  const [dataParameterTypes, setDataParameterTypes] = useState<ParameterTypesResponse[]>([]);
  const [dataPurchaseCriteria, setDataPurchaseCriteria] = useState<any[]>([]);
  const [dataPrioritySuppliers, setDataPrioritySuppliers] = useState<PrioritySuppliersResponse[]>([]);
  const [dataPartTypePerPart, setDataPartTypePerPart] = useState<PartTypePerPartResponse[]>([]);
  const [dataPeriodBusiness, setDataPeriodBusiness] = useState<IPeriodBusinessInfoState[]>(defaultValuePeriodBusiness());
  const [initialDataPeriodBusiness, setInitialDataPeriodBusiness] = useState<IPeriodBusinessInfoState[]>(defaultValuePeriodBusiness());
  const [formFiltersBlacklist, setFormFiltersBlacklist] = useState<any | null>(null);
  const [formFiltersFavorite, setFormFiltersFavorite] = useState<any | null>(null);
  const [dataUserPeriodBusiness, setDataUserPeriodBusiness] = useState<BusinessHourResponse[]>(dataPeriodBusiness);

  const rowHeadersPeriodBusiness = [
    getTranslateByKey('information.initialHour'),
    getTranslateByKey('information.finalHour'),
    getTranslateByKey('information.description'),
    <div style={{ textAlign: 'center' }}>
      {getTranslateByKey('information.actions')}
    </div>
  ];
  const [businessHourEdit, setBusinessHourEdit] =
    useState<IPeriodBusinessInfoState | null>(null);
  const [hasEditBusinessHour, setHasEditBusinessHour] = useState(false);
  const [deletePeriodBusiness, setDeletePeriodBusiness] = useState<string[]>(
    []
  );

  const [companyLogo, setCompanyLogo] = useState<File[]>([]);
  const [initialCompanyLogo, setInitialCompanyLogo] = useState<File[]>([]);
  const [hasLogoChanged, setHasLogoChanged] = useState(false);
  const supplierTypeReducer = useSupplierTypeReducer();
  const manufacturerReducer = useManufacturerReducer();
  const reasonReducer = useReasonReducer();
  const distributionRegionReducer = useDistributionRegionReducer();
  const [renderModal, setRenderModal] = useState<React.ReactNode>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
  const [
    blacklistAndMySuppliersDeleteItem,
    setBlacklistAndMySuppliersDeleteItem
  ] = useState<SaveSupplierCompanyRelationRequest[]>([]);
  const showBusinessHourGrid = !!guidInsurerParams;

  useEffect(() => {
    if (watcherCountry !== null) {
      dispatch(getSupplierType());

      const requestMake: ManufacturerRequest = {
        guidCountry: String(watcherCountry?.key)
      };
      dispatch(getManufacturers(requestMake));

      const requestRegion: DistributionRegionFilterRequest = {
        guidCountry: String(watcherCountry?.key)
      };
      dispatch(getDistributionRegion(requestRegion));

      const requestReason: ReasonFilterRequest = {
        guidCountry: String(watcherCountry?.key),
        idReasonType: ReasonTypeEnum.Blacklist
      };
      dispatch(getReason(requestReason));
    }
  }, [watcherCountry]);

  function validateForm() {
    const messages = [];

    if (dataContacts.length === 0)
      messages.push(
        getTranslateByKey('information.mustHaveAtLeastOneContact', true)
      );
    if (dataAddress.length === 0)
      messages.push(
        getTranslateByKey('information.mustHaveAtLeastOneAddress', true)
      );
    if (dataContacts.length > 0) {
      const primaryContact = dataContacts.find(
        contact => contact.isPrimaryContact
      );
      if (!primaryContact)
        messages.push(
          getTranslateByKey(
            'information.mustHaveAtLeastOnePrimaryContact',
            true
          )
        );
    }

    if (messages.length > 0) {
      messages.map(message => toast.error(message));
      throw new CustomError(messages.join('/n'), 'MISSING_FIELDS');
    }
  }

  function handleDeleteBusinessHourInfo(id: string) {
    setHasEditBusinessHour(false);
    setDataUserPeriodBusiness(prevState => {
      const index = prevState.findIndex(item => item.id === id);
      setDeletePeriodBusiness(prev => [...prev, id]);
      prevState.splice(index, 1);
      return [...prevState];
    });
  }

  function handleEditBusinessHoursInfo(businessHour: IPeriodBusinessInfoState) {
    setBusinessHourEdit(businessHour);
    setHasEditBusinessHour(true);
  }

  // FUNCTION TO FORMAT DATA
  const formatDataAddress = (
    addresses: IAddressInfoState[],
    isEditAddress = false
  ) => {
    return addresses.map(address => ({
      ...(isEditAddress && {
        guid: Guid.isGuid(address.id) ? address.id : Guid.EMPTY
      }),
      idAddressType: address.addressType.key,
      street: address.address,
      complement: address.complement,
      number: address.number,
      municipality: {
        guid: address.municipality.key
      }
    }));
  };

  async function createImageRequest(imageFile: File) {
    try {
      const image = await convertImageToBase64(imageFile);

      const dataImage =
        image?.type === 'url'
          ? image?.name
          : `data:${imageFile.type};base64,${image?.base64Image}`;

      return dataImage;
    } catch (error) {
      console.error('Erro ao converter imagem:', error);
      throw error;
    }
  }

  const isFormChanged = methods.formState.isDirty;
  const isContactsChanged = !lodash.isEqual(initialDataContacts, dataContacts);
  const isAddressChanged = !lodash.isEqual(initialDataAddress, dataAddress);
  const isPeriodBusinessChanged = !lodash.isEqual(initialDataPeriodBusiness, dataUserPeriodBusiness);
  const isBranchsChanged = !lodash.isEqual(initialDataBranchs, dataBranchs);
  const isLogoChanged = !lodash.isEqual(initialCompanyLogo, companyLogo);

  const hasChanges =
    isFormChanged ||
    isContactsChanged ||
    isAddressChanged ||
    isPeriodBusinessChanged ||
    isBranchsChanged ||
    isLogoChanged;

  async function handleSubmitRegisterInsurer(data: IInsurerRegisterForm) {
    try {
      validateForm();

      const formattedContacts = formattedContactSave(dataContacts);
      const formattedAddress = formatDataAddress(dataAddress);
      const formattedBranchs = dataBranchs.map(branch => String(branch.key));

      const haveCompanyLogo = !isNullUndefined(companyLogo[0]);

      const requestData: InsurerSaveRequest = removeEmptyValues({
        guidCountry: String(data?.country?.key),
        idStatusRegister: Number(data?.status?.key),
        companyName: data.companyName,
        registrationNumber: data.rfc,
        tradeName: data.tradeName,
        contacts: formattedContacts,
        addresses: formattedAddress,
        bodyShopIds: formattedBranchs,
        supplierCompanyRelations: [],
        visualIdentity: {
          logoInsurerBase64:
            hasLogoChanged && haveCompanyLogo
              ? await createImageRequest(companyLogo[0])
              : undefined,
          primaryColor: data.primaryColor,
          headerColor: data.headerColor,
          hasLogoChanged: hasLogoChanged || !haveCompanyLogo,
        }
      });

      insurerApi.saveInsurer(requestData).then(response => {
        const { result } = response.data;
        toast.success(
          getTranslateByKey('information.insurerSavedSuccessfully')
        );
        setIsEdit(true);
        setSearchParams({ insurerGuid: result.guid }, { replace: true });
      });
    } catch (error) {
      // eslint-disable-next-line no-empty
      if (error instanceof CustomError) {
      }
    }
    finally {
      setLoadingSubmit(false);
    }
  }

  async function handleSubmitEditInsurer(data: IInsurerRegisterForm) {
    try {
      validateForm();

      const resultConfirm = await getConfirmationReason(
        getTranslateByKey('information.confirmChangeTitle'),
        ReasonTypeEnum.ChangeCompany
      );

      if (!resultConfirm.confirmed) return;

      let filesRequest = undefined;
      if (resultConfirm.files && resultConfirm.files.length > 0) {
        filesRequest = await Promise.all(
          resultConfirm.files.map(async item => {
            const base64DataUrl = await toBase64(item);
            return {
              fileName: item.name,
              contentType: item.type,
              fileBase64: base64DataUrl as string
            };
          })
        );
      }

      const formattedContacts = formattedContactSave(dataContacts, true);
      const formattedAddress = formatDataAddress(dataAddress, true);
      const formattedBranchs = dataBranchs.map(branch => String(branch.key));

      const haveCompanyLogo = !isNullUndefined(companyLogo[0]);

      const requestData: InsurerSaveRequest = removeEmptyValues({
        guidCountry: String(data?.country?.key),
        idStatusRegister: Number(data?.status?.key),
        companyName: data.companyName,
        registrationNumber: data.rfc,
        tradeName: data.tradeName,
        contacts: formattedContacts,
        addresses: formattedAddress,
        bodyShopIds: formattedBranchs,
        guid: String(guidInsurerParams),
        supplierCompanyRelations: blacklistAndMySuppliersDeleteItem,
        changeJustification: {
          guidReason: resultConfirm.reason ? String(resultConfirm.reason.key) : null,
          reasonDescription: resultConfirm.observation || null,
          filesUpload: filesRequest
        },
        visualIdentity: {
          logoInsurerBase64:
            hasLogoChanged && haveCompanyLogo
              ? await createImageRequest(companyLogo[0])
              : undefined,
          primaryColor: data.primaryColor,
          headerColor: data.headerColor,
          hasLogoChanged: hasLogoChanged || !haveCompanyLogo,
        }
      } as InsurerSaveRequest);

      await insurerApi.saveInsurer(requestData);

      toast.success(getTranslateByKey('information.insurerEditSuccessfully'));
      setFormFiltersFavorite(null);
      setFormFiltersBlacklist(null);
      setHasLogoChanged(false);
    } catch (error) {
      // eslint-disable-next-line no-empty
      if (error instanceof CustomError) {
      }
    }
    finally {
      setLoadingSubmit(false);
    }
  }

  function loadInfoInsurer(guidInsurerRequest: string) {
    insurerApi
      .getRegistrationDataInsurer({ guid: guidInsurerRequest })
      .then(response => {
        const resultData = response.data.result;

        // Set Form values
        methods.setValue('country', {
          key: resultData.country.guid,
          value: resultData.country.name
        });
        methods.setValue('companyName', resultData.companyName);
        methods.setValue('rfc', resultData.registrationNumber);
        methods.setValue('status', {
          key: resultData.statusRegister.idStatusRegister,
          value: resultData.statusRegister.name
        });
        methods.setValue('tradeName', resultData.tradeName);

        if (resultData.companyPreferences) {
          methods.setValue(
            'primaryColor',
            resultData.companyPreferences.primaryColor
          );
          methods.setValue(
            'headerColor',
            resultData.companyPreferences.headerColor
          );

          const initialImages = [
            {
              name: resultData.companyPreferences.logoUrl,
              type: 'url'
            }
          ];
          setCompanyLogo(initialImages.filter(item => item.name) as File[]);
          setInitialCompanyLogo(initialImages.filter(item => item.name) as File[]);
          setHasLogoChanged(false);
        }

        // SET state values
        const formattedContacts = resultData.contacts.map(contact =>
          formattedContactGet(contact)
        );

        const formattedAddress = resultData.addresses.map(address => ({
          id: address.guid,
          address: address.street,
          complement: address.complement,
          number: address.number === '' ? null : address.number,
          zipCode: address.municipality.zipCode,
          addressType: {
            key: address.addressType.idAddressType,
            value: address.addressType.name
          },
          city: {
            key: address.municipality.city.guid,
            value: address.municipality.city.name
          },
          municipality: {
            key: address.municipality.guid,
            value: address.municipality.name
          },
          state: {
            key: address.municipality.city.state.guid,
            value: address.municipality.city.state.name
          }
        })) as IAddressInfoState[];
        const formattedPeriodBusiness: IPeriodBusinessInfoState[] =
          resultData.businessHours.map(period => ({
            id: period.guid,
            guid: period.guid,
            initialHour: new Date(period.startDate),
            finalHour: new Date(period.endDate),
            description: period.description
          }));

        const formattedBranchs: IOptionBranch[] = resultData.bodyShops.map(
          branch => {
            const convertedValue = branch.headQuarter
              ? `${branch.headQuarter.companyName} - ${branch.companyName}`
              : `${branch.companyName} - ${getTranslateByKey(
                'information.headquarters'
              )}`;
            const convertedNameBranch = branch.headQuarter
              ? branch.companyName
              : getTranslateByKey('information.headquarters');
            const convertedGroup = branch.headQuarter
              ? branch.headQuarter.companyName
              : branch.companyName;
            return {
              key: branch.guid,
              value: convertedValue,
              group: convertedGroup,
              nameBranch: convertedNameBranch
            };
          }
        );
        setDataParameterTypes(resultData.parameterTypes);
        setDataContacts(formattedContacts);
        setInitialDataContacts(lodash.cloneDeep(formattedContacts));
        setDataAddress(formattedAddress);
        setInitialDataAddress(lodash.cloneDeep(formattedAddress));
        setDataPeriodBusiness(formattedPeriodBusiness);
        setInitialDataPeriodBusiness(lodash.cloneDeep(formattedPeriodBusiness));
        setDataPurchaseCriteria(resultData.purchaseCriteria);
        setDataPrioritySuppliers(resultData.prioritySuppliers);
        setDataPartTypePerPart(resultData.partTypePerParts);
        setDataBranchs(formattedBranchs);
        setInitialDataBranchs(lodash.cloneDeep(formattedBranchs));
        setGuidCompany(resultData.company.guidCompany);
      })
      .catch(() => { })
      .finally(() => {
        setIsLoadingInfo(false);
      });
  }

  function handleBack() {
    navigate(-1);
  }
  function resetReducers() {
    // dispatch part type per part modal
    dispatch(resetReducerPosition());
    dispatch(resetReducerCategory());
    dispatch(resetReducerSubcategory());
    dispatch(resetReducerPartType());
  }

  function closeModal() {
    setBusinessHourEdit(null);
    setHasEditBusinessHour(false);
    setRenderModal([]);
    setOpen(false);
    resetReducers();
  }

  function openModal(nameProp: 'businessHours') {
    if (nameProp === 'businessHours') {
      setRenderModal(
        <BusinessHoursModal
          guidBodyShop={guidInsurerParams}
          guidInsurer={guidInsurerParams}
          hasEdit={hasEditBusinessHour}
          setHasEdit={setHasEditBusinessHour}
          businessHourEdit={businessHourEdit}
          dataPeriodBusiness={dataUserPeriodBusiness}
          setDataPeriodBusiness={setDataUserPeriodBusiness}
          setOpen={setOpen}
        />
      );
      setOpen(true);
    }
  }

  useEffect(() => {
    setDataUserPeriodBusiness(dataPeriodBusiness);
  }, [dataPeriodBusiness]);

  async function handleSaveSettings() {
    setLoadingSubmit(true);

    if (deletePeriodBusiness.length !== 0) {
      const filteredData = dataUserPeriodBusiness.filter(
        item => !deletePeriodBusiness.includes(item.guid)
      );

      const formattedPeriodBusiness = formatDataPeriodBusiness(filteredData);

      const deleteAllPeriodBusiness = [
        {
          deletePeriodBusiness,
          guidInsurer: guidInsurerParams,
          startDate: '',
          endDate: '',
          description: ''
        }
      ];

      const requestPeriodBusiness =
        formattedPeriodBusiness.length !== 0
          ? formattedPeriodBusiness
          : deleteAllPeriodBusiness;

      let filesRequest = undefined;
      let guidReason = null;
      let reasonDescription = null;

      if (guidInsurerParams) {
        const resultConfirm = await getConfirmationReason(
          getTranslateByKey('information.confirmChangeTitle'),
          ReasonTypeEnum.ChangeCompany
        );

        if (!resultConfirm.confirmed) {
          setLoadingSubmit(false);
          return;
        }

        if (resultConfirm.files && resultConfirm.files.length > 0) {
          filesRequest = await Promise.all(
            resultConfirm.files.map(async item => {
              const base64DataUrl = await toBase64(item);
              return {
                fileName: item.name,
                contentType: item.type,
                fileBase64: base64DataUrl as string
              };
            })
          );
        }

        guidReason = resultConfirm.reason ? String(resultConfirm.reason.key) : null;
        reasonDescription = resultConfirm.observation || null;
      }

      const payload = {
        companyBusinessHours: requestPeriodBusiness as any, // Cast to avoid TS error on the weird legacy struct
        changeJustification: {
          guidReason: guidReason,
          reasonDescription: reasonDescription,
          filesUpload: filesRequest
        }
      };

      companyBusinessHourApi
        .deleteBusinessHour(payload)
        .then(res => {
          toast.success(
            getTranslateByKey('businessHour.businessHourSavedSuccessfully')
          );
          const data = res.data.result;
          const convertedInitialhour = convertStringToHour(
            data.initialHour,
            data?.initialHourType?.key
          );
          const convertedFinalHour = convertStringToHour(
            data.finalHour,
            data?.finalHourType?.key
          );

          const intitialHourFormatted = new Date();
          intitialHourFormatted.setHours(
            convertedInitialhour.getHours(),
            convertedInitialhour.getMinutes()
          );

          const finalHourFormatted = new Date();
          finalHourFormatted.setHours(
            convertedFinalHour.getHours(),
            convertedFinalHour.getMinutes()
          );
          setDataUserPeriodBusiness(prevState => {
            const clonePrevState = lodash.cloneDeep(prevState);
            return clonePrevState.map(p => p.guid === data.guid ? {
              ...data,
              id: data.id,
              guid: data.guid,
              initialHour: intitialHourFormatted,
              finalHour: finalHourFormatted
            } : p) as IPeriodBusinessInfoState[];
          });
          setDataUserPeriodBusiness(formattedPeriodBusiness);
          setDeletePeriodBusiness([]);
          setIsEdit(false);
        })
        .finally(() => setLoadingSubmit(false));
    }
  }

  const convertStringToHour = (hour: string, type: string) => {
    const hourString = `${hour} ${type}`;
    const convertedDate = parse(hourString, 'hh:mm a', new Date());
    return convertedDate;
  };

  const formatDataPeriodBusiness = (
    periodBusiness: IPeriodBusinessInfoState[]
  ) => {
    return periodBusiness.map(period =>
      removeEmptyValues({
        guid: period.guid,
        guidInsurer: guidInsurerParams,
        guidBodyshop: period.guidBodyShop,
        startDate: formatDateToISOString(period.initialHour),
        endDate: formatDateToISOString(period.finalHour),
        description: period.description
      })
    );
  };

  useEffect(() => {
    if (guidInsurerParams) {
      setIsEdit(true);
      setIsLoadingInfo(true);
      loadInfoInsurer(guidInsurerParams);
    }
  }, [guidInsurerParams]);
  useEffect(() => {
    if (hasEditBusinessHour && businessHourEdit) {
      openModal('businessHours');
    }
  }, [hasEditBusinessHour, businessHourEdit]);

  async function handleSaveAll(data: IInsurerRegisterForm) {
    try {
      await handleSaveSettings();

      if (isEdit) {
        handleSubmitEditInsurer(data);
      } else {
        handleSubmitRegisterInsurer(data);
      }
    } catch (error) {
      console.error('Erro ao salvar dados:', error);
    }
  }

  if (isLoadingInfo) {
    return <LoadingComponent />;
  }

  function GeneralInfo() {
    return (
      <S.Container>
        <SectionInfo />
        <ContactInfo
          dataContacts={dataContacts}
          setDataContacts={setDataContacts}
          typeCompany=""
          watcherCountry={watcherCountry}
          companyType={CompanyTypeEnum.Insurer}
          companyName={methods.watch('companyName')}
        />
        <AddressInfo
          disableDeliveryAddress
          dataAddress={dataAddress}
          setDataAddress={setDataAddress}
          watcherCountry={watcherCountry}
          typeCompany=""
        />
        {isShowControlByElementId(Controls.IdVisualIdentity) && (
          <VisualIdentity
            companyLogo={companyLogo}
            setCompanyLogo={(files: File[]) => {
              setCompanyLogo(files);
              setHasLogoChanged(true);
            }}
          />
        )}
        <BodyshopCompanyInfo
          watcherCountry={watcherCountry}
          dataBranchs={dataBranchs}
          setDataBranchs={setDataBranchs}
        />
        {showBusinessHourGrid && (
          <BusinessHoursGrid
            rowHeaders={rowHeadersPeriodBusiness}
            dataPeriodBusiness={dataUserPeriodBusiness}
            handleEditBusinessHoursInfo={handleEditBusinessHoursInfo}
            handleDeleteBusinessHourInfo={handleDeleteBusinessHourInfo}
            openModal={openModal}
          />
        )}
        <KOGAreaButtons $isRegisterScreen>
          <SecondaryButton
            type="button"
            onClick={handleBack}
            id="id-registerInsurer-btn-back">
            {getTranslateByKey('information.back')}
          </SecondaryButton>
          <Button
            type="submit"
            onClick={methods.handleSubmit(handleSaveAll)}
            disabled={!hasChanges}
            loading={loadingSubmit}
            id="id-registerInsurer-btn-save">
            {getTranslateByKey('information.save')}
          </Button>
        </KOGAreaButtons>
        <KogModalSideComponent open={open} closeModal={() => closeModal()}>
          {renderModal || ''}
        </KogModalSideComponent>
        <ModalConfirmationReason />
      </S.Container>
    );
  }
  const insurerFormData = methods.getValues();
  const tabPanels = [
    {
      tab: getTranslateByKey('control.tabGeneralInfo'),
      panel: GeneralInfo(),
      isShowControl: true
    },
    {
      tab: getTranslateByKey('control.tabSettingsParts'),
      panel: (
        <TabSettingRegister
          guidInsurer={guidInsurerParams}
          guidBodyshop={null}
          purchaseCriteria={dataPurchaseCriteria}
          dataParameterTypes={dataParameterTypes}
          setDataParameterTypes={setDataParameterTypes}
          prioritySuppliers={dataPrioritySuppliers}
          partTypePerPart={dataPartTypePerPart}
          onSubmitInsurerEdit={handleSubmitEditInsurer}
          insurerFormData={insurerFormData}
          blacklistAndMySuppliersDeleteItem={blacklistAndMySuppliersDeleteItem}
          setBlacklistAndMySuppliersDeleteItem={
            setBlacklistAndMySuppliersDeleteItem
          }
        />
      ),
      isShowControl: isEdit && isShowControlByElementId(Controls.IdTabSettings)
    },
    {
      tab: getTranslateByKey('control.tabClaimSettings'),
      panel: (
        <TabInsurerClaimConfigurations
          guidInsurer={guidInsurerParams}
          guidCompany={guidCompany}
        />
      ),
      isShowControl: isEdit
    },
    {
      tab: getTranslateByKey('control.hierarchyLevels'),
      panel: <TabHierarchy />,
      isShowControl:
        isEdit &&
        (isShowControlByElementId(Controls.IdHierarchyLevelsClaims)
          || isShowControlByElementId(Controls.IdHierarchyLevelsParts))
    },
    {
      tab: getTranslateByKey('control.historical'),
      panel: <CompanyHistorical guidCompany={guidCompany} />,
      isShowControl:
        isEdit && isShowControlByElementId(Controls.IdCompanyHistoricalInsurer)
    }
  ];

  return (
    <ContainerScreen
      title={`
      ${getTranslateByKey('information.registration')}
      ${' > '}
      ${getTranslateByKey('information.registerInsurer')}`}>
      <KogTabsComponent
        tabPanels={tabPanels}
        tabCurrent={INTIAL_TAB_GENERAL_INFO}
        onChangeTab={() => { }}
      />
      <ModalConfirmationReason />
    </ContainerScreen>
  );
}

export default function InsurerRegisterScreenLoaded() {
  return (
    <InsurerRegisterProvider>
      <InsurerRegisterScreen />
    </InsurerRegisterProvider>
  );
}
